import { WindowKey } from "~/plugins/window/common";

export default defineNuxtPlugin(async (nuxtApp) => {
  nuxtApp.vueApp.provide(WindowKey, globalThis.window);
});
